import { Entry } from '@/modules/log'
import { Module } from 'vuex'
import { RootState } from '@/store/types'
import mutations from '@/modules/log/store/mutations'

export interface LogState {
    stack: Entry[]
}

const vuexModule: Module<LogState, RootState> = {
    namespaced: true,
    mutations,
    state: {
        stack: [],
    },
}

export default vuexModule
